import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from 'react-oidc-context'
import { WebStorageStateStore } from 'oidc-client-ts'
import './index.css'
import App from './App.tsx'
import { ServiceProvider } from './api/ServiceProvider'
import { registerVisualServiceWorker } from './lib/visualServiceWorker'

// Register the visual service worker early so it controls the page before
// any interactive .visual is opened.
registerVisualServiceWorker()

const queryClient = new QueryClient()

const oidcConfig = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY as string,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID as string,
  redirect_uri: `${window.location.origin}/callback`,
  response_type: 'code',
  scope: 'openid email profile',
  loadUserInfo: false,
  automaticSilentRenew: true,
  // Store tokens in sessionStorage — safer than localStorage for JWTs
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider {...oidcConfig}>
      <QueryClientProvider client={queryClient}>
        <ServiceProvider>
          <App />
        </ServiceProvider>
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>,
)
